// extracted by mini-css-extract-plugin
export var button = "_mf-2";
export var card = "_mf-0";
export var closeButtonContainer = "_mf-3";
export var iconContainer = "_mf-1";